export default __webpack_public_path__ + "static/media/book-big.fef14e73.png";